import React, { FC, useState } from 'react';
import { Drawer, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Chat } from 'stream-chat-react';

import { useChatClient } from 'hooks';
import { Layouts } from 'components';

import Channel from './Channel';
import ChannelList from './ChannelList';

const useStyles = makeStyles(theme => ({
  paper: {
    background: theme.palette.background.default,
  },
  '@global': {
    '.str-chat': {
      maxHeight: 'calc(100vh - 80px)',
    },
    '.str-chat.messaging .str-chat__load-more-button__button': {
      marginBottom: theme.spacing(2),
    },
    '.str-chat__channel-list-messenger': {
      minWidth: 0,
    },
    '.str-chat-channel-list .str-chat__channel-list-messenger__main': {
      padding: `0 ${theme.spacing(2)}px`,
    },
    '.str-chat-channel.messaging .str-chat__main-panel': {
      padding: 0,
      paddingRight: theme.spacing(2),
    },
    '@media screen and (max-width: 960px)': {
      '.str-chat-channel-list.messaging': {
        position: 'static',
      },
      '.str-chat-channel.messaging .str-chat__main-panel': {
        padding: `0 ${theme.spacing(2)}px`,
      },
    },
  },
}));

const Panel: FC = () => {
  const chatClient = useChatClient();
  const [mobileOpen, setMobileOpen] = useState(false);
  const classes = useStyles();

  if (!chatClient) {
    return null;
  }

  function handleToggleDrawer() {
    setMobileOpen(!mobileOpen);
  }

  function renderChannelList() {
    return (
      <Chat client={chatClient}>
        <Hidden smUp implementation="css">
          <Drawer
            keepMounted
            classes={{ paper: classes.paper }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleToggleDrawer}>
            <ChannelList onToggleDrawer={handleToggleDrawer} />
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <ChannelList />
        </Hidden>
        <Channel onToggleDrawer={handleToggleDrawer} />
      </Chat>
    );
  }

  return <Layouts.App1Column fullWidth desktopSize={12} main={renderChannelList()} />;
};

export default Panel;
